import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeButtonSkeleton } from './TypeButton';
import type { TypePageCaseStudySkeleton } from './TypePageCaseStudy';

export interface TypeBlockFeaturedCaseStudiesFields {
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Symbol;
    caseStudies?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypePageCaseStudySkeleton>>;
    button?: EntryFieldTypes.EntryLink<TypeButtonSkeleton>;
}

export type TypeBlockFeaturedCaseStudiesSkeleton = EntrySkeletonType<
    TypeBlockFeaturedCaseStudiesFields,
    'blockFeaturedCaseStudies'
>;
export type TypeBlockFeaturedCaseStudies<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeBlockFeaturedCaseStudiesSkeleton, Modifiers, Locales>;

export function isTypeBlockFeaturedCaseStudies<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockFeaturedCaseStudies<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockFeaturedCaseStudies';
}
